import { getInferredUri } from './getInferredUri';
import { Model } from '../Model';

interface ISetup {
  uri?: (() => string) | string;
}

export function defineUri<M extends Model, S extends ISetup>(ModelClass: new (...args: any[]) => M, setup?: S): (() => string) {
  if (setup && setup.uri) {
    if (typeof setup.uri === 'function') {
      return setup.uri;
    } else {
      const uri = setup.uri;
      return () => uri;
    }
  }

  return () => getInferredUri(ModelClass);
}